import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getCreditRequests(payload){
  try{
    const fd = new FormData();
    fd.append("admin_id",payload.admin_id||"");
    fd.append("page_no",payload.page_no||0);
    fd.append("keyword",payload.keyword||"");
    fd.append("status",payload.status||"");
    fd.append("sort_by",payload.sort_by||"");

    const res = await axios.post(
      apiBaseUrl+"credit/get_requests",
      fd
    );

    return res.data;

  }catch(e){
    return {status:false,success:"Request Failed"};
  }
}

/* =======================
   STATS
======================= */

export async function getCreditStats(admin_id){
  try{
    const fd=new FormData();
    fd.append("admin_id",admin_id);

    const res = await axios.post(
      apiBaseUrl+"credit/stats",
      fd
    );

    return res.data;

  }catch(e){
    return {status:false};
  }
}


export async function approveCreditRequest(payload) {
  try {
    const fd = new FormData();
    fd.append("creq_id", payload.creq_id);
    fd.append("admin_id", payload.admin_id);
    fd.append("approved_amount", payload.amount);
    fd.append("approved_tenure", payload.tenure);

    const res = await axios.post(
      `${apiBaseUrl}credit/approve_credit_request`,
      fd
    );

    return res.data;
  } catch (e) {
    return { status: false };
  }
}

export async function rejectCreditRequest(creq_id, admin_id, reason) {
  try {
    const fd = new FormData();
    fd.append("creq_id", creq_id);
    fd.append("admin_id", admin_id);
    fd.append("reason", reason);

    const res = await axios.post(
      `${apiBaseUrl}credit/reject_credit_request`,
      fd
    );

    return res.data;
  } catch (e) {
    return { status: false };
  }
}
